module.exports = __webpack_public_path__ + "media/Icons/PendingIcon-8b375b5f.png";